module.exports = __webpack_public_path__ + "img/php.d67a6c68.svg";